import "./../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { CreativeHobbiesEntries } from "../data/LinkCardEntries";
import { VideoGamePodium, TabletopGamePodium } from "../data/PodiumData";
import LinkCard from "../components/LinkCard";
import TextCard from "../components/TextCard";
import Podium from "../components/Podium";

export default function PersonalLife() {
  const OutdoorActivitiesText =
    "My favorite outdoor activities are hiking, kayaking, and disk golf. When hiking, I keep a record of every trail I trek in order to walk every trail on the preserve. While I am not very good at disk golf, I enjoy playing with friends. One of my kayaking goals is to go on a three-day trip down a river.";
  const OtherCreativeHobbiesText =
    "Other creative hobbies include video editing and 3D printing. I've been 3D-printing game pieces, models, and other gizmos since I was young. I enjoy creating and posting short videos. These hobbies have allowed me to gain experience and expand my skill set.";
  const VideoGameText =
    "Playing video games is one of the primary ways I relax after a long day. Below, I have listed my top three favorite games.";
  const TabletopGameText =
    "Playing board games with friends is one of my favorite social activities. I've collected more than 120 board games for this purpose and designed a board game binder to keep track of them. I've included a list of my three favorite board games below.";
  return (
    <div className="App min-w-screen min-h-screen bg-home-page ">
      <Navbar />
      <h1 className="text-5xl text-center my-8">Hobbies and Passions</h1>
      <div className="px-80 mdw:px-40 smw:px-20 xsw:px-4 gap-10 flex flex-col place-content-evenly mb-8">
        <h2 className="text-4xl">Outdoor Activities:</h2>
        <TextCard message={OutdoorActivitiesText} />
        <div className="gap-8 flex flex-row flex-wrap justify-center">
          <img className="h-24 w-24" src="/images/Hiking.png" alt="Hiking" />
          <img
            className="h-24 w-24"
            src="/images/Frisbee.png"
            alt="Disk Golf"
          />
          <img className="h-24 w-24" src="/images/Kayak.png" alt="Kayaking" />
        </div>
        <h2 className="text-4xl">Creative Hobbies:</h2>
        {CreativeHobbiesEntries.map((e) => (
          <LinkCard entry={e} />
        ))}
        <TextCard message={OtherCreativeHobbiesText} />
        <h2 className="text-4xl">Video Games:</h2>
        <TextCard message={VideoGameText} />
        <Podium entries={VideoGamePodium} />
        <h2 className="text-4xl">Tabletop Games:</h2>
        <TextCard message={TabletopGameText} />
        <Podium entries={TabletopGamePodium} />
      </div>
      <Footer />
    </div>
  );
}
